import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import {
  fieldsToGqlString,
} from '../../../util/shared/vue-global';

const { backend } = clients.direct;
const defaultCRAmtsFields = {
  prevUncolAmt: '',
  totAdjAmt: '',
  totPayAmt: '',
  newTaxRollAmt: '',
  newUncolAmt: '',
  totalStillDue: '',
  balanced: '',
};

const defaultCRFields = {
  paymentList: {
    taxId: '',
    taxYear: '',
    paymentNumber: '',
    workstation: '',
    payDate: '',
  },
  adjustmentList: {
    taxId: '',
    taxYear: '',
    adjDate: '',
  },
};

export const taxPstPeriod = {
  namespaced: true,
  state: () => ({
  }),
  mutations: {
  },
  actions: {
    async loadTaxPostingPeriod({ commit, dispatch }, {
      criteria, fields,
    }) {
      let results;
      try {
        const gqlfields = fields || defaultCRFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query taxPostingPeriod($criteria: postingPeriodCriteriaType) {
              taxPostingPeriod(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const { taxPostingPeriod } = results.data;
        commit('base/crud/setItems', ['baseCrudPaymentListKey', taxPostingPeriod.paymentList], { root: true });
        commit('base/crud/setItems', ['baseCrudAdjListKey', taxPostingPeriod.adjustmentList], { root: true });
        return taxPostingPeriod;
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting posting period transactions list.', { root: true });
        return [];
      }
    },
    async getTaxPostingPeriodAmts({ commit, dispatch }, {
      criteria, fields,
    }) {
      let results;
      try {
        const gqlfields = fields || defaultCRAmtsFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query getTaxPostingPeriodAmts($criteria: postingPeriodCriteriaType) {
              getTaxPostingPeriodAmts(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const { getTaxPostingPeriodAmts } = results.data;
        return getTaxPostingPeriodAmts;
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting posting period transactions list.', { root: true });
        return [];
      }
    },
    async generateTaxPostingPeriodReportsInBackend({ commit, dispatch }, {
      criteria,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query taxPostingPeriodGenearateReportInBackend($criteria: postingPeriodCriteriaType) {
              taxPostingPeriodGenearateReportInBackend(criteria: $criteria) {
                ${fieldsToGqlString({ success: '', message: '' })},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const { taxPostingPeriodGenearateReportInBackend } = results.data;
        if (taxPostingPeriodGenearateReportInBackend.success) {
          dispatch('flashSuccess', taxPostingPeriodGenearateReportInBackend.message, { root: true });
        } else {
          dispatch('flashError', taxPostingPeriodGenearateReportInBackend.message, { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting posting period transactions list.', { root: true });
      }
    },
    async getAllTheNewPostingPeriodPdfNames({ commit, dispatch }, {
      baseCrudKey, postProcessTrans,
    }) {
      let results;
      const fields = {
        taxrollSummary: '',
        taxrollAudit: '',
      };
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`{
            getAllTheNewPostingPeriodPdfNames {
              ${fieldsToGqlString(fields)},
            }
          }`,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { getAllTheNewPostingPeriodPdfNames } = results.data;
          const processedTransData = postProcessTrans
            ? postProcessTrans(getAllTheNewPostingPeriodPdfNames)
            : getAllTheNewPostingPeriodPdfNames;
          commit('base/crud/setItems', [baseCrudKey, processedTransData], { root: true });
          return processedTransData;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting min/max date ranges.', { root: true });
      }
      return {};
    },
  },
};

export default {};
